





















import Enumerable from "linq";
import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { Size, Color } from "../../../../../../../base/domain/drawing";
import { ModelEditableMixin, TabContainableMixin } from "../../../../../../../base/components/system/mixins";
import { TabSelector } from "../../../../../../../base/components/system/selectors";
import { IConfiguration, NewObjectKeys } from "../../../../../../domain/configuration";
import { FormatPageStructureEditor } from "../../../../../../domain/editableFormat";
import { FormatPageStructureEditableMixin } from "../../../mixins";
import { default as RectangleObjectLocator } from "./RectangleObjectLocator.vue";

@Component({
  components: {
    TabSelector,
    RectangleObjectLocator,
  },
})
export default class RectangleObjectLocators extends Mixins(ModelEditableMixin, TabContainableMixin, FormatPageStructureEditableMixin) {
  readPropertyOrDefault: <T>(reader: (source: FormatPageStructureEditor) => T, defaultValue: T) => T;

  @Prop()
  pallet: Color[];

  @Prop()
  locators: { key: NewObjectKeys, name: string, description: string }[];

  @Prop()
  shouldStamp: boolean;

  @Prop()
  stampSize: Size;

  @Prop()
  isShown: boolean;

  @Emit()
  located(): void {}

  $configuration!: IConfiguration;

  created(): void {
    this.initializeTabs();
  }

  initializeTabs(): void {
    this.tabs = Enumerable.from(this.locators)
      .select(l => ({
        name: l.name,
        description: l.description,
      }))
      .toArray();
    this.selectedTab = this.tabs[0];
  }
}
